import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import Image from "../../../../../base/multimedia/image/index.js";
import Title from "../../../../../base/text/title/index.js";
import ScrollHorizontal from "../../../../../structures/others/scroll-horizontal/index.js";
import * as S from "./styled.js";
export const MasonryMobile = ({ props  })=>{
    const { title ='' , items =[]  } = props ?? {};
    const resizeDefault = {
        width: 184,
        height: 250,
        operation: 'resize',
        suboperation: 'crop',
        quality: 85
    };
    return /*#__PURE__*/ _jsxs(S.MasonryWrapper, {
        "data-testid": "MasonryMobile",
        children: [
            /*#__PURE__*/ _jsx(Title, {
                title: title
            }),
            /*#__PURE__*/ _jsx(ScrollHorizontal, {
                children: Children.toArray(items.map((item)=>/*#__PURE__*/ _jsx(Image, {
                        resize: item.resize ?? resizeDefault,
                        ...item,
                        content: item.figcaption
                    })))
            })
        ]
    });
};
export default MasonryMobile;

//# sourceMappingURL=index.js.map